import { useCallback } from 'react';
import copy from 'copy-to-clipboard';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import LinkIcon from '@wix/da-ds/pkg/Icons/24x24/Link';
import { addNotification } from '../../Notifications/redux/actionCreators';
import { NotificationType } from '../../Notifications';
import { Url } from '@wix/da-url';
function useCopyLinkClick(url) {
    const dispatchAddNotification = useAction(addNotification);
    const onCopyLinkClick = useCallback(()=>{
        copy(url);
        dispatchAddNotification(NotificationType.Generic, {
            messageLocaleKey: 'share.linkCopied',
            cardProps: {
                iconComponent: LinkIcon
            }
        });
    }, [
        dispatchAddNotification,
        url
    ]);
    return {
        onCopyLinkClick
    };
}
export function useCopyDeviationLinkClick(targetDeviation) {
    return useCopyLinkClick(targetDeviation.url);
}
export function useCopyDeviationOrGallectionLinkClick(targetDeviation, targetGallection) {
    const url = targetGallection ? Url.userGalleryLink({
        username: targetGallection.owner.username,
        gallectionType: targetGallection.type,
        folderId: targetGallection.folderId,
        folderName: targetGallection.name
    }) : targetDeviation.url;
    return useCopyLinkClick(url);
}

//# sourceMappingURL=useCopyLinkClick.js.map